import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import "react-toastify/dist/ReactToastify.css";

import "./loader.scss";

const TrackToken = forwardRef(({ initiateAuth }, ref) => {
  const interval = useRef(null);
  const [counter, setCounter] = useState(0);

  const stopCounter = () => clearInterval(interval.current);

  const startCounter = () =>
    (interval.current = setInterval(() => {
      setCounter((prevState) => prevState + 1);
    }, 1000));

    const resetCounter = () => {
      setCounter(0);
      startCounter();
    };

  useImperativeHandle(ref, () => ({
    reset() {
      resetCounter();
    },
  }));

  useEffect(() => {
    localStorage.setItem("counter", counter);
    const signalCount = Number(localStorage.getItem("signal"));
    if (counter > 180 && signalCount <= 0) {
      setCounter(0);
      stopCounter();
      initiateAuth();
    }
  }, [counter]);

  useEffect(() => {
    resetCounter();
    return () => stopCounter(); 
  }, []); // Ensure this only runs once on mount

  return null; // This component does not render any visible output
});

export default TrackToken;
